(function () {
  'use strict';
  var id = 'mZPZOAhAddHqYQca8yEW-g';
  function init(root) {
    var form=root.querySelector('[data-nt-hulk-request]');
    if(!form||form.dataset.ready)return;
    form.dataset.ready='true';
    var mount=form.querySelector('[data-nt-hulk-mount]'), status=form.querySelector('[data-nt-hulk-status]');
    var messages=JSON.parse(form.querySelector('[data-nt-hulk-messages]').textContent);
    var target=document.createElement('div');target.id=id;target.className='pxFormGenerator';mount.replaceChildren(target);
    var attempts=0,timer,stopped=false;
    function attach(frame){if(frame.dataset.ntLoadBound)return;frame.dataset.ntLoadBound='true';frame.title=messages.iframe_title;frame.addEventListener('load',function(){status.textContent='';});frame.addEventListener('error',function(){status.textContent=messages.error;});}
    var observer=new MutationObserver(function(){mount.querySelectorAll('iframe').forEach(attach);});observer.observe(mount,{childList:true,subtree:true});
    function load(){
      if(stopped||!target.isConnected)return;
      if(typeof window.shouldLoadPopup==='function'){window.shouldLoadPopup(id);return;}
      if(++attempts<50){timer=setTimeout(load,100);return;}
      var frame=document.createElement('iframe'),url=new URL('https://formbuilder.hulkapps.com/corepage/customform');
      url.searchParams.set('id',id);url.searchParams.set('referrer_url',location.href);
      frame.src=url.href;frame.style.cssText='width:100%;height:1150px;border:0';attach(frame);target.appendChild(frame);
    }
    load();
    root.addEventListener('shopify:section:unload',function(){stopped=true;clearTimeout(timer);observer.disconnect();},{once:true});
  }
  function boot(scope){scope.querySelectorAll('[data-nt-custom-request]').forEach(init);}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',function(){boot(document);});else boot(document);
  document.addEventListener('shopify:section:load',function(e){if(e.target.matches('[data-nt-custom-request]'))init(e.target);else boot(e.target);});
})();
